import { Trans } from 'react-i18next'

import { FormatPrice } from '@reveni-io/reveni-ui'

const InstantRefundText = ({ orderAmount }) => {
  return (
    <div>
      <p>
        <Trans
          i18nKey="instantRefundProcessCompletedMessage"
          values={{ amount: orderAmount?.remaining_amount || 0 }}
          defaults="Los <strong><price>{{amount}}</price></strong> de tu reembolso ya están en tu cuenta, entra y compruébalo :)"
          components={{ strong: <strong />, price: <FormatPrice currency={orderAmount?.currency || 'EUR'} /> }}
        />
      </p>
    </div>
  )
}

export default InstantRefundText
